import React, { useEffect, useState, useRef } from 'react';
import '../../../../scss/common/inputs.scss';
import { observer } from 'mobx-react';
import Button from './Button';
import BucketService from './../../../../services/BucketService';
import { useStore } from '../../../../store/storeUtils';
import Snackbar from './Snackbar';
import ExtensionIcon from './ExtensionIcon';
import { getFileName } from './../../../../utils/Utils';
import { useCallback } from 'react';
import LoaderRef from '../../../common/LoaderRef';
import ProgressBarRef from '../../../common/ProgressBarRef';
import SimpleModal from '../../../common/SimpleModal/SimpleModal';
const extractPaths = array => {
  return array.map(obj => {
    let path = obj.message;
    path = path.replace(path.split('/')[0], '');
    return `${encodeURI(path)}`;
  }).sort((a, b) => a.localeCompare(b, 'en', {
    numeric: true
  }));
};
const FileUploader = observer(({
  title,
  description,
  supportedFiles = null,
  minDimension,
  maxDimension,
  minHeight,
  minWidth,
  path = '',
  type = 'image',
  buttonText = undefined,
  modalDeleteText = undefined,
  required = false,
  showPreview = true,
  onUpload = null,
  newPath = '',
  multiple = false,
  autoCreateThumb = false,
  validationFieldsNames = [],
  validatorErrors = []
}) => {
  const store = useStore();
  const inputFile = useRef(null);
  const loaderRef = useRef(null);
  const progressBarRef = useRef(null);
  const [value, setValue] = useState(path);
  const [preview, setPreview] = useState(null);
  const [showModalDelete, setShowModalDelete] = useState(false);
  let buttonTextToUse = buttonText;
  let modalDeleteTextToUse = modalDeleteText;
  if (!buttonTextToUse && !modalDeleteTextToUse) {
    switch (type) {
      case 'image':
        buttonTextToUse = 'Carica immagine';
        break;
      case 'video':
        buttonTextToUse = 'Carica video';
        break;
      case 'logo':
        buttonTextToUse = 'Carica logo';
        break;
      case 'pittogramma':
        buttonTextToUse = 'Carica pittogramma';
        break;
      case 'multi-image':
        buttonTextToUse = 'Carica immagini';
        break;
      default:
        break;
    }
  }
  if (!modalDeleteTextToUse) {
    switch (type) {
      case 'image':
        modalDeleteTextToUse = "Desideri cancellare l'immagine così da poterne caricare un altra?";
        break;
      case 'video':
        modalDeleteTextToUse = 'Desideri cancellare il video così da poterne caricare un altro?';
        break;
      case 'logo':
        modalDeleteTextToUse = 'Desideri cancellare il logo così da poterne caricare un altra?';
        break;
      case 'pittogramma':
        modalDeleteTextToUse = 'Desideri cancellare il pittogramma così da poterne caricare un altra?';
        break;
      case 'multi-image':
        modalDeleteTextToUse = "Desideri cancellare l'immagine selezionata?";
        break;
      default:
        break;
    }
  }
  useEffect(() => {
    // detect if image exists
    if (showPreview && value !== '' && type !== 'video' && !multiple) {
      if (loaderRef && loaderRef.current) {
        loaderRef.current.showLoader();
      }
      fetch("https://objectstorage.eu-frankfurt-1.oraclecloud.com/n/fronf8xprl08/b/tecma-assets-coll/o" + value).then(async response => {
        if (loaderRef && loaderRef.current) {
          loaderRef.current.hideLoader();
        }
        if (!response.ok) {
          setPreview(null);
          setValue('');
          return;
        }
        const data = await response.blob();
        var reader = new FileReader();
        reader.onload = function () {
          setPreview(reader.result);
        };
        reader.readAsDataURL(data);
      }).catch(() => {
        if (loaderRef && loaderRef.current) {
          loaderRef.current.hideLoader();
        }
        setPreview(null);
        setValue('');
      });
    }
  }, [value, setPreview, showPreview, path, multiple, type]);
  const removePreview = () => {
    setPreview(null);
    setValue('');
    if (onUpload) {
      onUpload('');
    }
  };
  const openUploadFile = () => {
    if (inputFile) {
      inputFile.current.click();
    }
  };

  // Callback to handle upload progress in percentage
  const onProgressUpdate = useCallback(percent => {
    progressBarRef.current.setProgress(percent);
  }, []);

  // Callback to handle upload errors
  const handleUploadError = useCallback(error => {
    progressBarRef.current.setProgress(-1);
    if (snackbarRef && snackbarRef.current) {
      snackbarRef.current.showSnackbar('Qualcosa è andato storto caricando i file.', 5000);
    }
  }, []);
  const uploadFile = BucketService.uploadSingleFile(store.baseUrl, onProgressUpdate);
  const uploadMultipleFile = BucketService.uploadMultipleFile(store.baseUrl, onProgressUpdate);
  const uploadMultipleFileWithThumbs = BucketService.uploadMultipleFileWithThumbs(store.baseUrl, onProgressUpdate);
  const handleFileUpload = async e => {
    const files = e.target.files;
    store.setUploading(true);
    if (files.length > 0) {
      const file = files[0];
      const extension = file.name.split('.')[file.name.split('.').length - 1];
      if (!multiple && !supportedFiles.includes(extension)) {
        // file not supported
        snackbarRef.current.showSnackbar('File non supportato.');
        store.setUploading(false);
      } else {
        // upload file
        progressBarRef.current.setProgress(0);
        if (multiple && autoCreateThumb) {
          // multiplo e con thumbs
          const uploadPath = `${newPath}`;
          await uploadMultipleFileWithThumbs(file, uploadPath, store.getProjectAssetFolder()).then(res => {
            store.setUploading(false);
            progressBarRef.current.setProgress(-1);
            const images = extractPaths(res.data.resultsImages);
            const thumbs = extractPaths(res.data.resultsThumbs);
            if (onUpload) {
              onUpload(images, thumbs);
            }
          }).catch(err => {
            store.setUploading(false);
            handleUploadError(err);
          });
        } else if (multiple) {
          // multiplo senza thumbs
          const uploadPath = `${newPath}`;
          await uploadMultipleFile(file, uploadPath, store.getProjectAssetFolder()).then(res => {
            store.setUploading(false);
            progressBarRef.current.setProgress(-1);
            const images = extractPaths(res.data.resultsImages);
            if (onUpload) {
              onUpload(images);
            }
          }).catch(err => {
            store.setUploading(false);
            handleUploadError(err);
          });
        } else {
          // singolo
          const uploadPath = `${newPath}${file.name}`;
          await uploadFile(file, uploadPath, store.getProjectAssetFolder()).then(res => {
            store.setUploading(false);
            progressBarRef.current.setProgress(-1);
            const images = extractPaths(res.data.results);
            const image = images[0];
            setValue(image);
            if (onUpload) {
              onUpload(image);
            }
          }).catch(err => {
            store.setUploading(false);
            handleUploadError(err);
          });
        }
      }
    } else {
      store.setUploading(false);
      // No file selected
    }
  };

  let snackbarRef = useRef(null);
  let invalidInput = validatorErrors && validatorErrors.filter(e => validationFieldsNames.includes(e.field)).length > 0;
  return /*#__PURE__*/React.createElement("div", {
    className: `cms-input cms-file-input-container type-${type}`
  }, /*#__PURE__*/React.createElement(LoaderRef, {
    ref: loaderRef
  }), /*#__PURE__*/React.createElement(ProgressBarRef, {
    ref: progressBarRef,
    text: "Stiamo caricando tutti i contenuti, attendi un attimo."
  }), /*#__PURE__*/React.createElement(Snackbar, {
    ref: snackbarRef,
    icon: "cross-white",
    iconColor: "#B03E3E"
  }), /*#__PURE__*/React.createElement("input", {
    type: "file",
    id: "file",
    ref: inputFile,
    accept: multiple ? '.zip' : supportedFiles.map(o => o.includes('.') ? `${o}` : `.${o}`).join(','),
    multiple: false,
    style: {
      display: 'none'
    },
    onChange: e => {
      handleFileUpload(e);
    },
    onClick: () => {
      inputFile.current.value = null;
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: `cms-file-input-left ${invalidInput ? 'invalid-input' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "cms-input-title cms-file-input-title"
  }, title, required ? '*' : ''), description ? /*#__PURE__*/React.createElement("div", {
    className: "cms-input-description cms-file-input-description"
  }, description) : null, multiple ? /*#__PURE__*/React.createElement("div", {
    className: "cms-input-description cms-file-input-description"
  }, "Seleziona lo zip con le immagini da caricare.") : null, supportedFiles ? /*#__PURE__*/React.createElement("div", {
    className: "cms-input-description cms-file-input-description cms-file-input-supported-files"
  }, "File supportati: ", supportedFiles.join(', ')) : null, maxDimension ? /*#__PURE__*/React.createElement("div", {
    className: "cms-input-description cms-file-input-description cms-file-input-dimension"
  }, "Dimensione massime: ", maxDimension.value, maxDimension.unit) : null, minHeight && minWidth ? /*#__PURE__*/React.createElement("div", {
    className: "cms-input-description cms-file-input-description cms-file-input-size"
  }, "Misure minime: ", minWidth, " x ", minHeight) : null, /*#__PURE__*/React.createElement(Button, {
    disabled: preview || value !== '',
    onClick: () => openUploadFile()
  }, buttonTextToUse)), (preview || type === 'video' || !showPreview) && value !== '' && !multiple ? /*#__PURE__*/React.createElement("div", {
    className: `cms-file-input-right`
  }, type !== 'video' && showPreview ? /*#__PURE__*/React.createElement("img", {
    className: "preview",
    src: preview,
    alt: "Preview"
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "cms-file-input-preview"
  }, /*#__PURE__*/React.createElement(ExtensionIcon, {
    fileName: value
  }), /*#__PURE__*/React.createElement("span", {
    className: "cms-file-name-container"
  }, getFileName(value)), /*#__PURE__*/React.createElement("div", {
    className: "icon medium trash",
    onClick: () => {
      setShowModalDelete(true);
    }
  }))) : null, /*#__PURE__*/React.createElement(SimpleModal, {
    onCancel: () => setShowModalDelete(false),
    showModal: showModalDelete,
    title: "Attenzione",
    subtitle: modalDeleteTextToUse,
    onSubmit: () => {
      setShowModalDelete(false);
      removePreview();
    }
  }));
});
export default FileUploader;